import type { PrefetchedSmartlinkData } from '@jira/issue__fetch-services/src/fetchORSDataSSR.tsx';
import { getIssueKey } from '@jira/router-resources__utils/src/getIssueKey.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { getIssueDescriptionSmartlinkData } from './getIssueDescriptionSmartlinkData.tsx';

export const issueDescriptionSmartlinkDataResource: RouteResource<
	PrefetchedSmartlinkData[] | null
> = createResource<PrefetchedSmartlinkData[] | null>({
	type: 'ISSUE_DESCRIPTION_SMARTLINK_DATA',
	getKey: ({ match }) => getIssueKey(match) ?? '',
	getData: (...args) => getIssueDescriptionSmartlinkData(...args),
});
